// extracted by mini-css-extract-plugin
module.exports = {"LoaderWrapper":"Loader_LoaderWrapper__1ZfOT","Loading":"Loader_Loading__1E2CI","Ripple":"Loader_Ripple__1cOGb"};